module.exports = __webpack_public_path__ + "img/food_13.da413ec6.jpg";